import { Field } from 'Components/Core';
import { ListDropdown } from 'Components/List';
import { WorksheetBatchUpdateQueryField } from 'Components/WorksheetBatchUpdate';
import { hasNonEmptyValue } from 'Lib/Any';

/**
 * Query for tests by work order
 */
export const WorksheetBatchUpdateWorkOrderQueryField: WorksheetBatchUpdateQueryField = {
  entryComponent: (
    <Field
      input={<ListDropdown />}
      label="Work Order"
      endpoint="list.workorders"
      queryParams={{ orderBy: 'WorkDate desc' }}
      searchImmediately={true}
      isClearable={false}
      maxResults={20}
      placeholder="Select or enter Work Order ID to search"
    />
  ),
  valueToParam: (option) => option?.value,
  paramToValue: (urlParam) =>
    hasNonEmptyValue(urlParam) ? { value: urlParam.toLowerCase(), label: urlParam.toLowerCase() } : undefined,
  // Hide work order selection when within a frame (QESTLab)
  // This is to mask an issue where we cannot query for an appropriate label for the work order (always injected via uri)
  // See QP-4701
  hidden: () => window.qest.isFrame ?? false,
};
